import instance from "../../Http-common";

export const authClear = () => {
    localStorage.removeItem('login');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    delete instance.defaults.headers.common['Authorization'];
}